import MobileTabsElement from './MobileTabsElement';
import MobileTabsElementDefinition from './MobileTabsElementDefinition';
import MobileTabsElementMetaData from './MobileTabsElementMetaData';

export default {
  MobileTabsElement: MobileTabsElement,
  MobileTabsElementDefinition: MobileTabsElementDefinition,
  MobileTabsElementType: MobileTabsElementMetaData.type,
};
